import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { changePasswordSchema } from '../../../models/schema/user'
import { Button } from '@mui/material'
import UserService from '../../../services/api/userManagement'
import { useState } from 'react'
import { notify } from '../../../common/notificationService'
import InputField from '../../../components/form-input/InputField'
import { ChangePasswordRequest } from '../../../models/types/user/current-user'

type Props = {
    handleCloseChangePassword: () => void
}
const DialogChangePassword = ({ handleCloseChangePassword }: Props) => {
    const [loading, setLoading] = useState(false);
    const schema = changePasswordSchema
    const {
        register,
        handleSubmit,
        formState: { errors, isDirty }
    } = useForm<ChangePasswordRequest>({
        resolver: yupResolver(schema),
        defaultValues: {
            password: "",
            confirmPassword: "",
            currentPassword: ""
        },
    });

    const onSubmit = async (data: ChangePasswordRequest) => {
        setLoading(true)
        try {
            const res = await UserService.changePassword({
                currentPassword: data.currentPassword,
                newPassword: data.password
            })

            if (res && res.content.status) {
                handleCloseChangePassword()
                notify('Thành công', 'Thay đổi mật khẩu thành công', 'success')
            }

        } catch (error) {
            notify("Lỗi", "Xảy ra lỗi", "danger");
        } finally {
            setLoading(false)
        }
    }

    return (
        <form className='min-w-[500px] mt-4' onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
                <InputField
                    name="currentPassword"
                    label="Mật khẩu hiện tại"
                    type="text"
                    register={register}
                    error={errors.currentPassword}
                    required={true}
                />
            </div>
            <div className="mb-4">
                <InputField
                    name="password"
                    label="Mật khẩu mới"
                    type="text"
                    register={register}
                    error={errors.password}
                    required={true}
                />
            </div>
            <div className="mb-4">
                <InputField
                    name="confirmPassword"
                    label="Xác nhận mật khẩu"
                    type="password"
                    register={register}
                    error={errors.confirmPassword}
                    required={true}
                />
            </div>
            <div className="flex justify-center gap-3 mt-2">
                <Button type='button' onClick={handleCloseChangePassword} sx={{ bgcolor: '#e5e7e9', color: '#000', width: '140px' }}>Hủy</Button>
                <Button type='submit' disabled={!isDirty} loading={loading} variant="outlined" sx={{ width: '140px', bgcolor: '#2563eb', color: '#fff' }}>Lưu thay đổi</Button>
            </div>
        </form>
    )
}

export default DialogChangePassword